const ContentModalErrorEdit = () => {
  return (
    <div className="modalMessage">
      <p className="modalMessageAlert">
        Não foi possível realizar a edição do nome social do aluno(a).
      </p>

      <p>
        Por favor, tente novamente mais tarde!
      </p>
    </div>
  );
}

export default ContentModalErrorEdit;